import { handleResponse, nextJsonApi } from '@/API/core';

const insuranceCompany = {
  getRowData: async (company_id: string) => {
    let response = null;
    try {
      response = await nextJsonApi.get(
        '/insurance-company?company_id=' + company_id
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  addInsurance: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/insurance-company', data);
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default insuranceCompany;
